export default __webpack_public_path__ + "static/media/master.b913381d.png";